export default {
    SEARCH_GROUP_WRAPPER: {
        hidden: true,
        type: 'group',
        id: 'search',
        children: [],
        icon: '$wSearch',
        sidebarIcon: '$wNavSearch'
    },
    CHILDREN: {
        SEARCH_MODULE: {
            type: 'module',
            id: 'search',
            routerLink: '/search',
            globalSearch: {
                index: 'globalSearch',
            }
        },
    }
}
